export const FETCH_PACKAGES_PENDING = "FETCH_PACKAGES_PENDING";
export const FETCH_PACKAGES_REJECTED = "FETCH_PACKAGES_REJECTED";
export const FETCH_PACKAGES_FULFILLED = "FETCH_PACKAGES_FULFILLED";



// WEBPACK FOOTER //
// ./src/constants/packages.js